import api from "@core/plugins/api";
import {TEMPLATE_CREATION_STEPS} from "@core/constants";

const createTemplateUrl = (contractType) => `et/template/${contractType}`;
const creationStepUrl = (templateId, stepSlug) => `et/template/${templateId}/step/${stepSlug}`;
const creationSummaryUrl = (templateId, stepSlug) => `et/template/${templateId}/${stepSlug}`;
const publishTemplateUrl = (templateId) => `/et/template/${templateId}/summarize`;
const duplicateAEDemandeUrl = (templateId) => `/et/template/duplicate/${templateId}`;
const activeContractUrl = () => `et/template/active-contract`;

export class CreationDemandService {
  static async initTemplate(contractType) {
    try {
      const { data } = await api.comet.post(createTemplateUrl(contractType));
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getCreationStep({ templateId, stepSlug }) {
    try {
      const url = stepSlug === TEMPLATE_CREATION_STEPS.SUMMARIZE ? creationSummaryUrl(templateId, stepSlug) : creationStepUrl(templateId, stepSlug);
      const { data } = await api.comet.get(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async saveCreationStep({ templateId, stepSlug, stepData, previousStep }) {
    try {
      const { data } = await api.comet.post(creationStepUrl(templateId, stepSlug), { data: { ...stepData, previous_step: previousStep } });
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async publish(templateId) {
    try {
      const response = await api.comet.post(publishTemplateUrl(templateId));
      return response && response.data && response.data.demandId;
    } catch (error) {
      throw error;
    }
  }

  static async duplicateAEDemand(templateId) {
    const response = await api.comet.post(duplicateAEDemandeUrl(templateId));
    return response.data;
  }

  static async getActiveContract() {
    const { data } = await api.comet.get(activeContractUrl());
    return data;
  }
}
